import axios from 'axios';
import React, { useState } from 'react';
import EditIcon from "@mui/icons-material/Edit";

const AdminPermissions = ({ onClose, Data, actionType }) => {
    console.log("Data", Data);
    console.log("actionType", actionType);

    const adminList = Array.isArray(Data) ? Data : [Data];

    const [currentActionType, setCurrentActionType] = useState(actionType);

    const [editedAdmins, setEditedAdmins] = useState(
        adminList.map(admin => ({
            ...admin,
            roleData: typeof admin.roleData === "string"
                ? JSON.parse(admin.roleData).map(role => ({
                    ...role,
                    view: !!role.view,
                    create: !!role.create,
                    edit: !!role.edit,
                    delete: !!role.delete,
                    export: !!role.export
                }))
                : admin.roleData || []
        }))
    );

    const handleCheckboxChange = (adminId, roleIndex, field) => {
        setEditedAdmins(prevAdmins =>
            prevAdmins.map(admin =>
                admin.adminId === adminId
                    ? {
                        ...admin,
                        roleData: admin.roleData.map((role, index) =>
                            index === roleIndex ? { ...role, [field]: !role[field] } : role
                        )
                    }
                    : admin
            )
        );
    };

    const handleSave = async () => {
        console.log("Saved Data:", editedAdmins);
        try {
            const response = await axios.post('http://localhost:4000/admincreate', {
                formValues: editedAdmins[0]
            });
            console.log('Response:', response.data);
    
            if (typeof onClose === 'function') {
                console.log("Closing section...");
                onClose();
            }
        } catch (error) {
            console.error('Error creating/updating application:', error);
            console.error("Error Response Data:", error.response?.data);
        }
    };

    const handleInputChange = (adminId, field, value) => {
        setEditedAdmins(prevAdmins =>
            prevAdmins.map(admin =>
                admin.adminId === adminId ? { ...admin, [field]: value } : admin
            )
        );
    };

    return (
        <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {currentActionType === "edit" ? "Edit Admin Details" : "Permissions"}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
    
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <div className="d-flex flex-column gap-0 mp-2 rounded justify-content-center align-items-center">
                                <div className="w-100 mb-4">
                                    <div className="w-100 gap-4 gap-md-0 justify-content-start mb-3 row">
                                        {editedAdmins.map((admin) => (
                                            <div key={admin.adminId}>
                                                <div>
                                                    <div className="px-3 py-2 card-header">
                                                        <div className="d-flex align-items-center">
                                                            <img src="/images/card-advance-sale.png" height="60px" alt="Admin" />
                                                            <div className="d-flex flex-column justify-content-center align-items-start pt-1 mx-3">
                                                                {currentActionType === "edit" ? (
                                                                    <>
                                                                        <div style={{ display: "flex", gap: "10%" }}>
                                                                            <div className="flex-1">
                                                                                <label className="form-label">First Name</label>
                                                                                <input
                                                                                    className="form-control w-full"
                                                                                    type="text"
                                                                                    value={admin.firstName}
                                                                                    onChange={(e) => handleInputChange(admin.adminId, "firstName", e.target.value)}
                                                                                />
                                                                                
                                                                                <label className="form-label mt-2">Mobile Number</label>
                                                                                <input
                                                                                    className="form-control w-full"
                                                                                    type="text"
                                                                                    value={admin.contactNo}
                                                                                    onChange={(e) => handleInputChange(admin.adminId, "contactNo", e.target.value)}
                                                                                />
                                                                            </div>

                                                                            <div className="flex-1">
                                                                                <label className="form-label">Last Name</label>
                                                                                <input
                                                                                    className="form-control w-full"
                                                                                    type="text"
                                                                                    value={admin.lastName}
                                                                                    onChange={(e) => handleInputChange(admin.adminId, "lastName", e.target.value)}
                                                                                />
                                                                                
                                                                                <label className="form-label mt-2">Email</label>
                                                                                <input
                                                                                    className="form-control w-full"
                                                                                    type="email"
                                                                                    value={admin.email}
                                                                                    onChange={(e) => handleInputChange(admin.adminId, "email", e.target.value)}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <strong className="text-uppercase">{admin.firstName} {admin.lastName}</strong>
                                                                        <span>Contact: {admin.contactNo}</span>
                                                                        <span>Email: {admin.email}</span>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
    
                                                    <div className="mt-2 px-3 pb-3">
                                                        <table className="table table-bordered text-center">
                                                            <thead className="bg-gray-200">
                                                                <tr>
                                                                    <th>Section</th>
                                                                    <th>View</th>
                                                                    <th>Create</th>
                                                                    <th>Edit</th>
                                                                    <th>Delete</th>
                                                                    <th>Export</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {admin.roleData.map((role, index) => (
                                                                    <tr key={role._id || index}>
                                                                        <td>{role.name}</td>
                                                                        {['view', 'create', 'edit', 'delete', 'export'].map((field) => (
                                                                            <td key={field} className="text-center">
                                                                                {currentActionType === "edit" ? (
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={role[field]}
                                                                                        onChange={() => handleCheckboxChange(admin.adminId, index, field)}
                                                                                    />
                                                                                ) : (
                                                                                    <span style={{ color: role[field] ? "green" : "red" }}>
                                                                                        {role[field] ? "✅" : "❌"}
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    {/* Edit Button in Permissions Mode */}
                                                    {currentActionType === "permissions" && (
                                                        <div className="mt-3 text-end">
                                                            <button
                                                                className="btn btn-primary"
                                                                onClick={() => setCurrentActionType("edit")} // Switch to Edit Mode
                                                            >
                                                                  <EditIcon fontSize="small" /> Edit
                                                            </button>
                                                        </div>
                                                    )}

                                                    {/* Save Button in Edit Mode */}
                                                    {currentActionType === "edit" && (
                                                        <div className="mt-3 text-end">
                                                            <button className="btn btn-primary" onClick={handleSave}>
                                                                Save
                                                            </button>
                                                        </div>
                                                    )}
                                                
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                </div>
            </div>
        </div>
    );
};

export default AdminPermissions;
